import React, { useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import Fade from "react-reveal/Fade";

function PhysicalMechanical() {

  const { t } = useTranslation();

  const data = [
    {
      type: "mansorymesh.18",
      commissions: "mansorymesh.24",
      margin: "mansorymesh.25",
      currency: "mansorymesh.26",
    },
    {
      type: "mansorymesh.19",
      commissions: "390",
      margin: "> 1400",
      currency: "1800",
    },
    {
      type: "mansorymesh.20",
      commissions: "200000",
      margin: "55000",
      currency: "71000",
    },
    {
      type: "mansorymesh.21",
      commissions: "25",
      margin: "2,2",
      currency: "2,2",
    },
    {
      type: "mansorymesh.22",
      commissions: "mansorymesh.27",
      margin: "mansorymesh.28",
      currency: "mansorymesh.29",
    },
    {
      type: "mansorymesh.23",
      commissions: "7",
      margin: "1,9",
      currency: "1,9",
    },
  ];

  const tabs = ["mansorymesh.15", "mansorymesh.16", "mansorymesh.17"];
  const [activeTab, setActiveTab] = useState("mansorymesh.15");

  const getTabContent = () => {
    return data.map((item, index) => {
      let value;
      switch (activeTab) {
        case "mansorymesh.15":
          value = item.commissions;
          break;
        case "mansorymesh.16":
          value = item.margin;
          break;
        case "mansorymesh.17":
          value = item.currency;
          break;
        default:
          value = "";
      }

      return (
        <Fade bottom delay={index * 150} key={item.type + activeTab}>
          <tr>
            <td className="p-2 bg-[#272727]"><Trans>{t(item.type)}</Trans></td>
            <td className="p-2 bg-[#272727]"><Trans>{t(value)}</Trans></td>
          </tr>
        </Fade>
      );
    });
  };

  return (
    <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
      <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto">
        <div className="flex flex-col items-center justify-center">
          <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.3]">
            <Trans>{t("mansorymesh.12")}</Trans>
          </p>
          <p className="text-[14px] open-sans xl:text-[20px] text-[#F26522] mt-[15px]">
            <Trans>{t("mansorymesh.13")}</Trans>
          </p>
        </div>

        <div className="mt-[65px]">
          {/* Desktop Table */}
          <div className="hidden md:block overflow-x-auto">
            <table className="min-w-full border-separate border-spacing-y-[4px] relative overflow-hidden">
              <thead className="bg-[#F26522] open-sans text-[#1D1D1D] text-[14px] xl:text-[20px]">
                <tr>
                  <th className="p-[15px] text-left font-[300]">
                    {t("mansorymesh.14")}
                  </th>
                  <th className="p-[15px] text-left font-[300]">
                    {t("mansorymesh.15")}
                  </th>
                  <th className="p-[15px] text-left font-[300]">
                    {t("mansorymesh.16")}
                  </th>
                  <th className="p-[15px] text-left font-[300]">
                    {t("mansorymesh.17")}
                  </th>
                </tr>
              </thead>
              <tbody className="text-[14px] xl:text-[16px]">
                {data.map((item, index) => (
                  <Fade bottom delay={index * 150} key={item.type}>
                    <tr>
                      <td className="p-[15px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                        <Trans>{t(item.type)}</Trans>
                      </td>
                      <td className="p-[15px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                        <Trans>{t(item.commissions)}</Trans>
                      </td>
                      <td className="p-[15px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                        <Trans>{t(item.margin)}</Trans>
                      </td>
                      <td className="p-[15px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                        <Trans>{t(item.currency)}</Trans>
                      </td>
                    </tr>
                  </Fade>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Tabs */}
          <div className="block md:hidden">
            <div className="flex flex-wrap gap-2 mb-4">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-[10px] py-[15px] w-[104px] flex-grow text-[14px] xl:text-[16px] ${
                    activeTab === tab
                      ? "bg-[#F26522] open-sans text-[14px] font-[300] text-[#1D1D1D]"
                      : "bg-[#272727] open-sans text-[14px] font-[300] text-[#F6F6F6]"
                  }`}
                >
                  {t(tab)}
                </button>
              ))}
            </div>
            <table
              className="w-full open-sans border-separate border-spacing-y-[2px] text-[14px] xl:text-[16px]"
              key={activeTab}
            >
              <thead className="bg-[#F26522] text-[#1D1D1D] ">
                <tr>
                  <th className="p-2 text-left font-[300]">{t("mansorymesh.14")}</th>
                  <th className="p-2 text-left font-[300]">{t(activeTab)}</th>
                </tr>
              </thead>
              <tbody className="text-[#F6F6F6] font-[300] open-sans">
                {getTabContent()}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PhysicalMechanical;
